import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from '@ibk/shared-translation';
import ProductCard from '../ProductCard/ProductCard';
import BeneficiosCard from '../ProductCard/ProductsCards/BeneficiosCard';
import ContabilidadeDigitalCard from '../ProductCard/ProductsCards/ContabilidadeDigitalCard';
import ContaPjCard from '../ProductCard/ProductsCards/ContaPjCard';
import styles from './ProductsList.module.css';
export default function ProductsList({ products, onProductClick, 'data-testid': dataTestId }) {
    const { t } = useTranslation();
    const productCards = React.useMemo(() => ({
        'escritorio-contabilidade-digital': ContabilidadeDigitalCard,
        'empresa-contabilidade-digital': ContabilidadeDigitalCard,
        'escritorio-beneficios': BeneficiosCard,
        'empresa-beneficios': BeneficiosCard,
        'escritorio-conta-pj': ContaPjCard,
        'empresa-conta-pj': ContaPjCard,
        'escritorio-programa-fidelidade': ProductCard,
    }), []);
    const handleProductClick = (id) => {
        if (onProductClick) {
            onProductClick(id);
        }
    };
    return (_jsxs("div", { className: styles.container, "data-testid": dataTestId ?? 'products-list', children: [_jsx("h2", { className: styles.title, "data-testid": `${dataTestId ?? 'products-list'}-title`, children: t('products.title') }), _jsx("div", { className: styles.grid, "data-testid": `${dataTestId ?? 'products-list'}-grid`, children: products.map((product, index) => {
                    const ProductCardComponent = productCards[product.id] || ProductCard;
                    return (_jsx(ProductCardComponent, { id: product.id, title: product.title, icon: product.icon, status: product.status, onClick: handleProductClick, "data-testid": `${dataTestId ?? 'products-list'}-item-${index}`, metaData: product.metaData, isLoading: product.isLoading, statusElement: product.statusElement }, product.id));
                }) })] }));
}
